var TimeUnits;
(function (TimeUnits) {
    TimeUnits[TimeUnits["Millisecond"] = 1] = "Millisecond";
    TimeUnits[TimeUnits["Second"] = 1000] = "Second";
    TimeUnits[TimeUnits["Minute"] = 60000] = "Minute";
    TimeUnits[TimeUnits["Hour"] = 3600000] = "Hour";
    TimeUnits[TimeUnits["Day"] = 86400000] = "Day";
    TimeUnits[TimeUnits["Week"] = 604800000] = "Week";
})(TimeUnits || (TimeUnits = {}));
export default TimeUnits;
//# sourceMappingURL=TimeUnits.js.map